import React from 'react'
import { useTranslate } from 'react-admin'
import {
  TooltipContainer,
  TooltipDescriptionCell,
  TooltipFooter,
  TooltipHeader,
  TooltipLabel,
  TooltipRow,
  TooltipTable,
} from '../ProjectConfigurations.styles'

export const InverterReplacementModellingTooltip: React.FC = () => {
  const translate = useTranslate()

  const options = [
    {
      label: translate('Replace'),
      description: translate(
        'Inverter is replaced at the end of warranty. The replacement cost is calculated using the method specified.'
      ),
    },
    {
      label: translate('Extend Beyond Warranty'),
      description: translate(
        'Inverter continues to operate beyond the warranty period. No further replacement occurs.'
      ),
    },
  ]

  return (
    <TooltipContainer>
      <TooltipHeader>{translate('Inverter Replacement Modelling Options:')}</TooltipHeader>
      <TooltipTable>
        {options.map((option, index) => (
          <TooltipRow key={index}>
            <TooltipLabel>{option.label}</TooltipLabel>
            <TooltipDescriptionCell>{option.description}</TooltipDescriptionCell>
          </TooltipRow>
        ))}
      </TooltipTable>
      <TooltipFooter>
        {translate(
          'When replacement is selected, the replacement cost is calculated using one of three methods: Component cost (pre-inflation) (original purchase price adjusted by annual inflation rate), Manual cost (pre-inflation) (fixed override value adjusted by annual inflation rate), or Cost per kW Inflation Adjusted (cost per kW capacity adjusted by annual inflation rate).'
        )}
      </TooltipFooter>
    </TooltipContainer>
  )
}
